const footerLinks = [
  {
    title: 'Leistungen',
    links: [
      { label: 'Alle Leistungen', url: '/services' },
      { label: 'Webdesign Freiburg', url: '/webdesign-freiburg' },
      { label: 'Neue Webseite erstellen', url: '/contact' },
      { label: 'Premium Redesign anfragen', url: '/contact' },
      { label: 'Performance-Optimierung', url: '/contact' },
      { label: 'AI Chatbot integrieren', url: '/contact' },
      { label: 'SEO & Sichtbarkeit verbessern', url: '/contact' }
    ]
  },
  {
    title: 'Unternehmen',
    links: [
      { label: 'Über mich', url: '/about' },
      { label: 'Preise', url: '/pricing' },
      { label: 'Kontakt aufnehmen', url: '/contact' },
      { label: 'Impressum', url: '/impressum' },
      { label: 'Datenschutz', url: '/datenschutz' }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="bg-brand-brown text-white pt-16 sm:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 mb-12 sm:mb-16">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/78978ce1-55a2-450d-acbd-0ca2f7ed24f7.png"
                alt="BR Webdesign & AI Solutions Logo"
                className="w-12 h-12 object-contain"
                loading="lazy"
                decoding="async"
                width={48}
                height={48}
              />
              <div className="flex flex-col leading-tight">
                <span className="text-xl font-caprasimo">BR Webdesign</span>
                <span className="text-[10px] font-semibold text-brand-beige-light tracking-wider uppercase">&amp; AI Solutions</span>
              </div>
            </div>
            <p className="text-brand-beige-light mb-4 leading-relaxed text-sm">
              Ich verwandle Webseiten in digitale Verkaufsmaschinen. Webdesign, AI Chatbots &amp; SEO von Benjamin Reick.
            </p>
            <div className="space-y-3 text-sm">
              <a href="tel:01623651571" className="flex items-center gap-2 text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer py-2 min-h-[44px]">
                <i className="ri-phone-line"></i> 0162 365 1571
              </a>
              <a href="mailto:info-aiagents@web.de" className="flex items-center gap-2 text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer py-2 min-h-[44px]">
                <i className="ri-mail-line"></i> info-aiagents@web.de
              </a>
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((column, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4 sm:mb-6">{column.title}</h3>
              <ul className="space-y-1">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.url}
                      className="inline-block text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer text-sm py-2 min-h-[44px] flex items-center"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-brand-beige-light text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} BR Webdesign &amp; AI Solutions – Benjamin Reick. Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap justify-center items-center gap-6 sm:gap-8 text-sm">
            <a href="/datenschutz" className="text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer py-2 min-h-[44px] flex items-center">
              Datenschutzerklärung
            </a>
            <a href="/impressum" className="text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer py-2 min-h-[44px] flex items-center">
              Impressum
            </a>
            <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="text-brand-beige-light hover:text-brand-green transition-colors cursor-pointer py-2 min-h-[44px] flex items-center">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
